import { useState, useEffect, useRef } from 'react';
import GalleryRenderer from './galleryRenderer';

const GalleryScaledRenderer = ({ comp, containerHeight, isLargeScreen }) => {
    const contentRef = useRef(null);
    const [scale, setScale] = useState(1);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        const updateScale = () => {
            if (contentRef.current) {
                const contentHeight = contentRef.current.offsetHeight;
                if (contentHeight > containerHeight) {
                    setScale(containerHeight / contentHeight);
                } else {
                    setScale(1);
                }
                setIsReady(true);
            }
        };
        
        updateScale();
        // Optional: Add a small delay to ensure GalleryRenderer has rendered images
        const timer = setTimeout(updateScale, 100);
        return () => clearTimeout(timer);
    }, [comp, isLargeScreen, containerHeight]);

    return (
        <div className="scaled-component-container" style={{ opacity: isReady ? 1 : 0, transition: 'opacity 0.2s' }}>
            <div
                ref={contentRef}
                className="scaled-component-content"
                style={{ transform: `scale(${scale})` }}
            >
                <GalleryRenderer comp={comp} />
            </div>
        </div>
    );
};

export default GalleryScaledRenderer;
